module.exports = __webpack_public_path__ + "static/media/logo.7e34914e.png";